export default __webpack_public_path__ + "static/media/SurveyIcon.4b79291c.svg";